<script lang="ts">
	import FontSpan from '$lib/components/typography/FontSpan.svelte';
	import { formatPrice, numberWithCommas } from '$lib/service/WalletManager';
	import type { OrderTransaction } from '$lib/types';
	export let tx: OrderTransaction;
</script>

<div class="flex flex-row gap-1">
	{#if tx.network === 'mainnet' && !tx.isOffer}
		<div class="flex icon icon-mainnet-eth22 price-icon" />
		<FontSpan varient="body-B-08" class="text-gray-30">{numberWithCommas(`${formatPrice(tx.price)}`)}</FontSpan>
		<FontSpan varient="body-SB-06" class="text-gray-70 pt-[2px]">ETH</FontSpan>
	{/if}
	{#if tx.network === 'polygon' && !tx.isOffer}
		<div class="flex icon icon-polygon-matic22 price-icon" />
		<FontSpan varient="body-B-08" class="text-gray-30">{numberWithCommas(`${formatPrice(tx.price)}`)}</FontSpan>
		<FontSpan varient="body-SB-06" class="text-gray-70 pt-[2px]">MATIC</FontSpan>
	{/if}
	{#if tx.network === 'mainnet' && tx.isOffer}
		<div class="flex icon icon-mainnet-weth22 price-icon" />
		<FontSpan varient="body-B-08" class="text-gray-30">{numberWithCommas(`${formatPrice(tx.price)}`)}</FontSpan>
		<FontSpan varient="body-SB-06" class="text-gray-70 pt-[2px]">WETH</FontSpan>
	{/if}
	{#if tx.network === 'polygon' && tx.isOffer}
		<div class="flex icon icon-polygon-wmatic22 price-icon" />
		<FontSpan varient="body-B-08" class="text-gray-30">{numberWithCommas(`${formatPrice(tx.price)}`)}</FontSpan>
		<FontSpan varient="body-SB-06" class="text-gray-70 pt-[2px]">WMATIC</FontSpan>
	{/if}
</div>
